export const TOPIC_EXPLORER_PROMPT_NAME = 'topicExplorer';
export const TOPIC_EXPLORER_PROMPT_NAME_PREMIUM = 'topicExplorerPremium';
